import { Button, TextSpinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import getCopyModalTranslations from './getCopyModalTranslations'
import useCopySchedule from './useCopySchedule'

interface Props {
  onClose: () => void
  shiftsCount: number
  restDaysCount: number
}

const CopyShiftModal = ({ onClose, shiftsCount, restDaysCount }: Props) => {
  const [{ view }] = useSchedule()

  const { description } = getCopyModalTranslations(shiftsCount, restDaysCount)

  const previousView = view.previousPeriod

  const { onConfirm: onConfirmView, submitting } = useCopySchedule({
    originalView: previousView,
    targetView: view,
  })

  const noShiftsOrRestDays = shiftsCount === 0 && restDaysCount === 0
  const disabled = submitting || noShiftsOrRestDays

  return (
    <Modal
      illustration="handing-paper"
      title={i18n.t('shift_management.copy_shift.title')}
      description={description}
      onClose={onClose}
      onSubmit={onConfirmView}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('shift_management.copy_shift.cancel')}
          </Button>
          <Button disabled={disabled} submit>
            {i18n.t('shift_management.copy_shift.submit')}
          </Button>
        </>
      }
    >
      {submitting && <TextSpinner text={i18n.t('shift_management.actions.copying_shifts')} />}
    </Modal>
  )
}

export default observer(CopyShiftModal)
